import React from 'react';
import { Link } from 'react-router-dom'
import why_work from '../../../assets/images/why-work.png';
import CustomModalView from '../../../common/input/customModal/customModalView';



const ClientSelectionView = (props) => {
        return (
            <>
                <section className="login-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 login-center">
                                <div className="login-form-main">
                                    <div className="registration-form_wrapper">
                                        <div className="content">
                                            <img src={why_work} alt="" />
                                            <h3>carerconnect</h3>
                                            <h4>Whenever Wherever</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div className="col-lg-6 login-center">
                                <div className="login-form-main">
                                    <h3 style={{color: 'white', marginBottom: '20px'}}>Select Employer Type</h3>
                                    <div className="registration-form_wrapper" style={{padding : '90px 97px '}}>
                                        <div className="content">
                                             <div className="login-form" style={{width: 'auto',margin: '0px', padding : '0px'}}>
                                                <form>
                                                    <div className="field-box" style={{margin: '29px', marginTop : '10px'}}>
                                                        <button onClick={(e) => props.handeldata('nursing_home')} type="button" className="btn btn-red regular">Nursing Home <i className="fa fa-suitcase" aria-hidden="true"> </i></button>
                                                    </div>
                                                     <div className="field-box" style={{margin: '29px', marginTop : '10px'}}>
                                                        <button onClick={(e) => props.handeldata('local_council')} type="button" className="btn btn-red regular">Local Council  <i className="fa fa-suitcase" aria-hidden="true"> </i></button>
                                                    </div>
                                                     <div className="field-box" style={{margin: '29px', marginTop : '10px'}}>
                                                        <button onClick={(e) => props.handeldata('private_individual')} type="button" className="btn btn-red regular">Private Individual  <i className="fa fa-user" aria-hidden="true"> </i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </section>
                <CustomModalView
                    modal_show={props.modal_show}
                    authResponse = {props.authResponse}
                    showCustomModal= {props.showCustomModal}
                    hideCustomModal={props.hideCustomModal}
                    custom_model = {props.custom_model}
                    />
            </>
        )

}

export default ClientSelectionView;